'use client'

import { Dialog } from '@vinted/web-ui'

import { ResponseError, ResponseCode } from '@marketplace-web/core-api/api-client-util'

import BumpShadowBannedError from './ErrorModals/BumpShadowBannedError'
import BumpItemDeletedError from './ErrorModals/BumpItemDeletedError'

type Props = {
  show: boolean
  bumpOptionsError?: ResponseError
  onClose: () => void
}

const BumpErrorModal = ({ show, bumpOptionsError, onClose }: Props) => {
  const prepareResponseCode = bumpOptionsError?.code

  const renderModalContent = () => {
    switch (prepareResponseCode) {
      case ResponseCode.ActionRestricted:
        return <BumpShadowBannedError handleClose={onClose} />

      default:
        return <BumpItemDeletedError handleClose={onClose} />
    }
  }

  return (
    <Dialog show={show} testId="bump-error-modal">
      {renderModalContent()}
    </Dialog>
  )
}

export default BumpErrorModal
